import { FirebaseError } from "firebase/app";

/** User-facing message for Firebase Phone Auth / reCAPTCHA errors (Portuguese). */
export function getFirebasePhoneAuthToastMessage(error: unknown): string {
  if (error instanceof FirebaseError) {
    switch (error.code) {
      case "auth/too-many-requests":
        return "Muitas tentativas. Aguarde alguns minutos antes de solicitar um novo código.";
      case "auth/captcha-check-failed":
      case "auth/invalid-app-credential":
        return "Conclua a verificação do reCAPTCHA e tente novamente.";
      case "auth/quota-exceeded":
        return "Limite de envios atingido. Tente mais tarde.";
      case "auth/invalid-phone-number":
      case "auth/missing-phone-number":
        return "Número de telefone inválido. Verifique e tente novamente.";
      case "auth/operation-not-allowed":
        return "Envio de SMS não disponível no momento. Tente outra opção ou mais tarde.";
      default:
        break;
    }
  }
  return "Não foi possível enviar o código. Tente novamente.";
}

/** reCAPTCHA / app verification failures — safe to reset widget and retry once. */
export function isFirebasePhoneAuthCaptchaError(error: unknown): boolean {
  if (!(error instanceof FirebaseError)) return false;
  return (
    error.code === "auth/captcha-check-failed" ||
    error.code === "auth/invalid-app-credential"
  );
}
